import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { ImageGalleryComponent } from '@shared/components';
import { CommsService } from '@services/comms/comms.service';
import { ObjectsService } from '@services/objects/objects.service';
import { MediaViewerComponent } from '@shared/components/media-viewer/media-viewer.component';

import { filter, includes, map, split } from 'lodash';
import { ObjectItem } from '@services/objects/objects.interfaces';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class ViewerService {
  constructor(
    private modalController: ModalController,
    private commsService: CommsService,
    private objectsService: ObjectsService,
    private logger: NGXLogger
  ) {}

  public showByUrl(src: string): void {
    if (src) {
      this.modalController.create({
        component: ImageGalleryComponent,
        componentProps: {
          images: [{
            url: src,
            thumbnailUrl: src,
          }],
          index: 0
        },
        cssClass: 'image-gallery-modal'
      }).then((modal) => {
        modal.present();
      });
    }
  }

  public showByType(url: string, type: string): void {
    const objectType = this.objectsService.getObjectType(type);

    if (objectType === 'image') {
      this.showByUrl(url);
    } else if (includes(['video', 'audio'], objectType)) {
      this.modalController.create(<any>{
        component: MediaViewerComponent,
        cssClass: 'media-screen-modal',
        componentProps: {URL: url, type: objectType}
      }).then((element: HTMLIonModalElement) => {
        element.present();
      });
    } else {
      this.logger.debug(`Opening ${url} in another tab`);
      window.open(url, '_blank');
    }
  }

  public showByObjectId(objectID: number, alias?: string, rowID?: number): void {
    let object = this.objectsService.getCachedObjectById(objectID, alias, true);

    if (rowID) {
      object = this.objectsService.getRevisionByID(objectID, rowID) as ObjectItem;
      object = this.objectsService.translateObject(object);
    }

    if (object) {
      const objectUrl = this.commsService.objectURI(object.objectID, false, false, true, object.revision);
      this.showByType(objectUrl, object.mediaType);
    } else {
      const url = this.commsService.objectURI(objectID, false);
      this.showByUrl(url);
    }
  }

  public openGallery(attachments: { objectID: number; mediaType: string }[], index: number = 0) {
    attachments = this.filterAttachments(attachments);
    this.modalController.create({
      component: ImageGalleryComponent,
      componentProps: {
        images: map(attachments, (attachmentsItem) => ({
          url: this.commsService.objectURI(attachmentsItem.objectID, false),
          thumbnailUrl: this.commsService.objectURI(attachmentsItem.objectID, true),
          mediaType: attachmentsItem.mediaType
        })),
        index
      },
      cssClass: 'image-gallery-modal'
    }).then((modal) => {
      modal.present();
    });
  }

  public filterAttachments(attachments) {
    return filter(attachments, (attachmentsItem) => includes(['video', 'image'], split(attachmentsItem?.mediaType, '/')[0]) && attachmentsItem?.objectID as boolean);
  }
}
